'use strict'

const defaultMenu = false

const menu = {
  isOpen: defaultMenu
}

export default menu



// WEBPACK FOOTER //
// ./src/store/Menu.js